export default __webpack_public_path__ + "static/media/desc-services-image-04.ca5e2621.png";